import { render, staticRenderFns } from "./EmptyCardIcon.vue?vue&type=template&id=a6563f3e"
import script from "./EmptyCardIcon.vue?vue&type=script&lang=js"
export * from "./EmptyCardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports